import { VisibilityOff } from '@tempo-io/sui-icons';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '@/common/utils/colors';

interface VisualizationColorSwatchProps {
  color: string;
  label: string;
  isHidden?: boolean;
}

export function VisualizationColorSwatch({
  color,
  label,
  isHidden,
}: VisualizationColorSwatchProps) {
  const { t } = useTranslation();
  const squareStyles: CSSProperties = {
    backgroundColor: color,
    borderColor: `#${Colors.gray200.hex}`,
  };

  return (
    <div className="flex items-center gap-2 p-2 pl-3 w-full min-w-0">
      <div className="w-[14px] h-[14px] rounded border shrink-0" style={squareStyles} />
      <div className="flex-1 min-w-0 flex items-center gap-1">
        <div className={`text-xs line-clamp-1 break-all ${Colors.gray600.text}`}>{label}</div>
        {isHidden && (
          <VisibilityOff
            size={14}
            className={`shrink-0 ${Colors.gray600.text}`}
            aria-label={t(($) => $.loopVisualization.layout.colorLegend.hiddenHeader)}
          />
        )}
      </div>
    </div>
  );
}
